<!-- 制作印章 -->
<template>
    <page-container class="mould-container"
                    v-loading="loading || loadingSeal"
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideNavigate">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item><a>印模管理</a></el-breadcrumb-item>
        </el-breadcrumb>

        <div class="curr-seal-box">
            <div class="header">
                <el-row
                    type="flex"
                    justify="space-between"
                >
                    <el-col :span="5">
                        <el-button
                            class="grey-text small-font"
                            type="text"
                            v-if="!hideNavigate"
                            @click="$router.push('/home')"
                        >&lt; 返回上一页</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-popover
                            placement="bottom"
                            width="100"
                            trigger="click"
                        >
                            <div class="seal_update_wrapper">
                                <div
                                    v-if="ownedMould.length === 0"
                                    class="no_update_seal"
                                >
                                    <p>暂无可更新印章</p>
                                </div>
                                <div v-else>
                                    <div
                                        v-for="item in ownedMould"
                                        :key="item.id"
                                        class="seal_update_item"
                                        @click="()=>beforeUpload(item)"
                                    >
                                        {{item.mouldName}}
                                    </div>
                                </div>
                            </div>
                            <el-button
                                slot="reference"
                                class="seal_update_button"
                            >印模更新</el-button>
                        </el-popover>
                    </el-col>
                </el-row>

            </div>
        </div>
        <!-- 印模列表 -->
        <div class="mould-content">
            <!-- 已申请的印模 -->
            <div v-for="mould in ownedMould" :key="mould.mouldType">
                <div class="img-box">
                    <img :src="`${BASE_APP_PATH}/seal/image?fileKey=${mould.picKey}`"  class="mould-img" />
                </div>
                <div class="text-center">{{ mould.mouldName }}</div>
            </div>


            <!-- 审核中的印模 -->
            <div v-for="mould in remainderMould" :key="mould.mouldType">
                <div v-if="mould.status == 2" class="mould-box">
                    <p class="error-text">审核失败！失败原因：{{ mould.reason}}</p>
                    <el-button @click="()=> beforeUpload(mould)" size="mini">重新上传</el-button>
                </div>

                <div v-else-if="mould.status == 0" class="mould-box">
                    <p class="blue-text">审核中，请耐心等待</p>
                    <span>预计需要1-2个工作日</span>
                </div>

                <div v-else class="mould-box" @click="()=> beforeUpload(mould)">上传印模</div>

                <div class="text-center">{{ mould.mouldName }}</div>
            </div>

        </div>
        <el-upload
            v-show="false"
            action=""
            ref="upload"
            class="upload"
            id="upload"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleChange"
        >
        <el-button class="clickToUpload" size="small" type="primary" ref="clickToUpload"></el-button>
        </el-upload>

        <!-- 印模申请 -->
        <apply-moulage-dialog
            v-if="showApplyDialog"
            :mouldInfo="mouldInfo"
            :showApplyDialog.sync="showApplyDialog"
            :mouldImg.sync="uploadImgSrc"
            :imgSize="imgSize"
            @initMould="initMould"
            @handleChange="handleChange">
        </apply-moulage-dialog>

        <create-mould-img
            v-if="showCreateMouldDialog"
            :showCreateMouldDialog.sync="showCreateMouldDialog"
            :imgList="certificateSealList"
            @upload="upload"
            @handleImgByCreat="handleImgByCreat"
        >

        </create-mould-img>


    </page-container>
</template>

<script>
// import { mapGetters } from 'vuex';
import Matting from '@/assets/utils/matting.js';
import PageContainer from '../../components/container.vue';
import applyMoulageDialog from './apply-mould.vue';
import wholeMould from './mouldData';
import CreateMouldImg from './create-mould-img.vue';

export default {
    name: 'MouldSeal',
    components: { PageContainer, applyMoulageDialog, CreateMouldImg},
    data () {
        return {
            showApplyDialog: false,

            showCreateMouldDialog: false,

            /** 已拥有的印模 */
            ownedMould: [],

            wholeMould: wholeMould,

            /** 未申请的印模 */
            remainderMould: [],

            /** 上传的图片 */
            uploadImgSrc: '',

            /** 上传时选中的印模 */
            mouldInfo: {},

            loading: true,

            loadingSeal: true,

            loadingMask: null,

            // 上传图片大小
            imgSize:'',
            certificateSealList: [],
        };
    },
    props: {
        hideNavigate: Boolean
    },
    inject: ['app'],
    computed: {
        isUkeyLogin() {
            return this.$store.getters.isLP && !this.$store.getters.isEtl;
        },
        areaType() {
            return this.$store.getters.system.areaType;
        },
    },
    watch: {
        '$store.getters': {
            handler() {
                if (this.areaType === 'MHQ' && this.isUkeyLogin) {
                    this.wholeMould = {
                        ...this.wholeMould,
                        '06': '业务章',
                    };
                }
            },
            immediate: true,
            deep: true,
        }
    },
    mounted () {
        this.initMould();
        this.getExistSeal();
    },
    methods: {
        beforeUpload(val) {
            this.mouldInfo = val;
            if (!this.certificateSealList.length) {
                this.upload(val);
            } else {
                this.showCreateMouldDialog = true;
            }
        },
        async getExistSeal() {
            this.loadingSeal = true;
            try {
                const { data } = await this.axios({
                    url: '/seal/lp/certificate/seal',
                    method: 'GET',
                });
                if(!data.code) {
                    this.certificateSealList = data.result.map( item => {
                        return {
                            ...item,
                            pic_data: `data:image/${item.pic_type};base64,${item.pic_data}`
                        };
                    });
                }
                this.loadingSeal = false;
            } catch(error) {
                this.loadingSeal = false;
                console.log(error);
            }
        },


        upload() {
            this.mouldInfo = this.mouldInfo;
            this.$refs['clickToUpload'] && this.$refs['clickToUpload'].$el.click();
        },
        // 获取已拥有的印模
        async ownedmouldQuery() {
            try {
                const resp = await this.axios({
                    url: '/seal/mould/query',
                    method: 'GET',
                });
                const { data: { result, code, message }} = resp;
                if(code === 0) {
                    this.ownedMould = result.map( item => {
                        return {
                            ...item,
                            mouldName: this.wholeMould[item.mouldType]
                        };
                    }).filter((item)=>!item.updating);
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.log(error);
            }

        },
        // 组合印模数据
        async initMould() {
            try {
                await this.ownedmouldQuery();

                const remainder = Object.keys(this.wholeMould).filter( key => !this.ownedMould.find( mould => mould.mouldType === key) );
                const promiseArr = remainder.map( (key) => this.mouldStatus(key));
                Promise.allSettled(promiseArr).then( (resultArr) => {
                    this.remainderMould = resultArr.reduce( ( total, item, currentIndex ) => {
                        const { data: { result = {} } } = item.value;
                        const index =  total.findIndex( key => key === result.mouldType );
                        if(index > -1) {
                            total[index] = {
                                ...result,
                                mouldName:  this.wholeMould[total[index]],
                            };
                        } else {
                            total[currentIndex] = {
                                mouldType: total[currentIndex],
                                mouldName: this.wholeMould[total[currentIndex]],
                            };
                        }
                        return total;
                    }, remainder);
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },

        // 印模申请状态查询
        mouldStatus(sealType) {
            return this.axios({
                url: '/seal/mould/mouldapply/query',
                method: 'GET',
                params: { sealType }
            });
        },

        async handleImgByCreat(img) {
            try {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: '图片处理中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)',
                    visible: true,
                });
                const matting = new Matting(img);
                this.uploadImgSrc = await matting.createStream();
                this.showApplyDialog = true;
            } catch (err) {
                console.log(err);
            } finally {
                this.loadingMask && this.loadingMask.close();
            }
        },

        handleChange(file) {
            try {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: '图片处理中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.5)',
                    visible: true,
                });
                let type = file.name.split('.')[1].toUpperCase();
                let types = ['JPG', 'PNG', 'JPEG', 'GIF'];
                let img = file.size ? file : file.target.files[0];
                this.imgSize = img.size / 1024 ;
                // const isLt20K = img.size / 1024 < 20;

                if (!types.includes(type)) {
                    this.$message.error('文件仅支持png，jpg，gif，jpeg格式！');
                    return false;
                }

                // 取消印章上传图片前大小检查
                // if (!isLt20K) {
                //     this.$message.error('上传图片大小不能超过 20KB！');
                //     return false;
                // }
                let reader = new FileReader();
                reader.onload = async (e) => {
                    // 抠图处理
                    const matting = new Matting(e.target.result);
                    this.uploadImgSrc = await matting.createStream();

                    this.showApplyDialog = true;
                };
                reader.readAsDataURL(file.raw);
            } catch (err) {
                console.log(err);
            } finally {
                this.loadingMask && this.loadingMask.close();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.mould-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 140px;
    height: 140px;
    margin-bottom: 8px;
    border-radius: 50%;
    border: 1px solid #E5E7EA;
    word-wrap: break-word;
    word-break: break-all;
    font-size: 12px;
    color: #7F8997;
    text-align: center;
}
.mould-img {
    width: 140px;
}
.img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 140px;
}
.error-text {
    color: #ED521F;
    margin-bottom: 10px;
}
.mould-container {
    .curr-seal-box {
        padding: 15px 30px 30px;
        .seal-container {
            min-height: 300px;
        }
        .header {
            margin-bottom: 10px;
            .seal_update_button {
                color: @red;
                background: @white;
                border: 1px solid @red;
            }
            .seal_update_button:hover {
                background: @white;
            }
        }
    }

    .mould-content {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 30px;
        border: 1px solid @border-color-base;
        color: #4c596e;
    }
}
.seal_update_wrapper {
    .no_update_seal {
        margin: 10px 5px;
    }
    .seal_update_item {
        margin-left: -12px;
        padding: 10px 20px;
        width: calc(100% + 24px);
        cursor: pointer;
    }
    .seal_update_item:hover {
        background: #f5f7fa;
    }
}
</style>


